export const BROWSER_TYPES = {
    UNKNOWN: 'Unknown',
    OPERA: 'Opera',
    FIREFOX: 'Firefox',
    SAFARI: 'Safari',
    EDGE: 'Edge',
    CHROME: 'Chrome',
    BRAVE: 'Brave',
};

export const MOBILE = {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
};

export const COOKIE_NAMES = {
    USER_SESSION: 'ultkn',
    USER_API_KEY: 'userApiKey',
    USER_AUTH_TOKEN: 'uatkn',
    USER_LOGIN_ATTEMPT: '_lgatt',
    USER_REDIRECT: 'redirect',
    API_TOKEN: 'apiToken',
    PREFERRED_LANGUAGE: 'pref_lang', // cross subdomain language preference
};

export const STORE_NAME = {
    USER: 'user',
    DEVICE: 'device',
    USER_API_KEY: 'userApiKey',
    LIVETV: 'liveTv',
    USER_PROFILE_LIST: 'profileList',
    SELECTED_PROFILE: 'selectedProfile',
    USERNAME: 'username',
    LEGACY_INGS: 'ings',
    SUB_STATES: 'sub_states',
    API_TOKEN: 'apiV2Token',
    REFRESH_TOKEN_ATTEMPS: 'refreshTokenAttemps',
    CC_SUB_INFO: 'cc_sub_info',
    CC_SUB_ADDON_INFO: 'cc_sub_addon_info',
    BUNDLE_SUB_INFO: 'bundle_sub_info',
    IS_THAMAYOUZ: 'is_tamayouz',
    TIER_NAME: 'tierName',
    PLAN_UPGRADE_DATA: 'plan_upgrade_data',
    REFRESH_TOKEN_RETRY_QUEUE: 'refreshAndRetryQueue',
    REFRESH_TOKEN_API_IN_PROGRESS: 'refreshApiInProgress',
    IS_QR_SIGNUP_FLOW: 'is_qr_signup_flow',
    REFRESH_TOKEN_API_STATUS_IN_DD: 'refreshApiSatatusDD',
    CC_MIXPANEL_PROPS: 'ccMixPanelProps',
    NEW_AND_HOT_TAB_INDEX: 'nwTabIndex',
    SCROLL_OBJECT: 'scrollobject',
    HEADER_ENRICHMENT_FLOW: 'headerEnrichmentFlow',
    USER_LOGIN_DETAIL: 'user_sub_info',
    GUEST_PUBLIC_CONFIG: 'guest_public_config',
    USER_SUMARRY_PAGE_URL: 'user_summary_page',
    CC_ADDONS_DATA: 'cc_addons',
    BUNDLE_AND_SAVE_DISCOUNT: 'bundle_save_discount'
};

export const AXIOS_ERROR = {
    ERR_FR_TOO_MANY_REDIRECTS: 'ERR_FR_TOO_MANY_REDIRECTS',
    ERR_BAD_OPTION_VALUE: 'ERR_BAD_OPTION_VALUE',
    ERR_BAD_OPTION: 'ERR_BAD_OPTION',
    ERR_NETWORK: 'ERR_NETWORK',
    ERR_DEPRECATED: 'ERR_DEPRECATED',
    ERR_BAD_RESPONSE: 'ERR_BAD_RESPONSE',
    ERR_BAD_REQUEST: 'ERR_BAD_REQUEST',
    ERR_NOT_SUPPORT: 'ERR_NOT_SUPPORT',
    ERR_INVALID_URL: 'ERR_INVALID_URL',
    ERR_CANCELED: 'ERR_CANCELED',
    ECONNABORTED: 'ECONNABORTED',
    ETIMEDOUT: 'ETIMEDOUT',
};

export const MIXPANEL_EVENTS = {
    API_ERROR_FAILURE: 'Error - Api - Failure',

    LOGIN_OTP_VIEW: 'Login - OTP Verification - View',
    LOGIN_OTP_VERIFICATION_SUCCESS: 'Login - OTP Verification - Success',
    LOGIN_OTP_VERIFICATION_FAILED: 'Login - OTP Verification - Failed',
    LOGIN_OTP_VERIFICATION_RESEND: 'Login - OTP Verification - Resend',
    LOGIN_OTP_VERIFICATION_PASSWORD_OPTION: 'Login - OTP Verification - Password option',
    LOGIN_OTP_VERIFICATION_ATTEMPT: 'Login - OTP Verification - Attempt',
    LOGIN_STARTED: 'Login Started',
    LOGIN_FAILED: 'Login Failed',
    LOGIN_ATTEMPT: 'Login Attempt',
    LOGIN_SUCCESS: 'Login Success',
    LOGIN_USERNAME_SUBMITTED: 'Username Submitted',
    LOGIN_PASSWORD_SUBMITTED: 'Password Submitted',
    LOGIN_OTP_SUBMITTED: 'OTP Submitted',
    LOGIN_OTP_RESENT: 'OTP Resent',
    LOGIN_COMPLETED: 'Login Completed',

    FORGOT_PASSWORD_VIEW: 'Forgot Password - View',
    FORGOT_PASSWORD_ATTEMPT_FAILURE: 'Forgot Password - Attempt - Failure',
    FORGOT_PASSWORD_INPUT: 'Forgot Password - Input',
    FORGOT_PASSWORD_OTP_VERIFICATION_FAILED: 'Forgot Password - OTP Verification - Failed',
    FORGOT_PASSWORD_NEW_PASSWORD_FAILED: 'Forgot Password - New Password - Failed',
    FORGOT_PASSWORD_SUCCESS: 'Forgot Password - Success',
    FORGOT_PASSWORD_OTP_VERIFICATION_RESEND: 'Forgot Password - OTP Verification ReSend',
    FORGOT_PASSWORD_EXISTING_USER_CLICK: 'Forgot Password - Existing User Click',

    MANAGE_ADDONS_REMOVE_PACKAGE_ATTEMPT: 'Manage Addons - Remove Package Attempt',
    MANAGE_ADDONS_REMOVE_PACKAGE_SUCCESS: 'Manage Addons - Remove Package - Success',
    MANAGE_ADDONS_REMOVE_PACKAGE_FAILED: 'Manage Addons - Remove Package - Fail',

    MANAGE_ADDONS_REMOVE_CLICK: 'Manage Addons - Unsubscribe Click',
    MANAGE_ADDONS_REMOVE_POPUP_VIEW: 'Manage Addons - Unsubscribe Popup View',
    MANAGE_ADDONS_REMOVE_POPUP_CLOSE: 'Manage Addons - Unsubscribe Popup Close',

    MANAGE_ADDONS_VIEW: 'Manage Addons - View',
    MANAGE_ADDONS_UNSUBSCRIBE: 'Manage Addons - Unsubscribe',
    MANAGE_ADDONS_ADD_NEW_ADDON_CLICK: 'Manage Addons - Add New Addon - Click',
    MANAGE_FREE_ADDONS_VIEW: 'Manage Free Addons - View',
    MANAGE_PAID_ADDONS_VIEW: 'Manage Paid Addons - View',
    MANAGE_B2B_ADDONS_VIEW: 'Manage B2B Addons - View',
    MANAGE_B2B_ADDONS_PIN_VERIFICATION_VIEW: 'Manage Addons - PIN Verification - View', //both
    MANAGE_B2B_ADDONS_PIN_VERIFICATION_ATTEMPT: 'Manage Addons - PIN Verification - Attempt', //both
    MANAGE_B2B_ADDONS_PIN_VERIFICATION_SUCCESS: 'Manage Addons - PIN Verification - Success', //both
    MANAGE_B2B_ADDONS_PIN_VERIFICATION_FORGOT_PIN: 'Manage Addons - PIN Verification - Forgot PIN', //both
    MANAGE_B2B_ADDONS_PIN_VERIFICATION_FAILED: 'Manage Addons - PIN Verification - Failed', //both
    MANAGE_ADDONS_MANAGE_FREE_ADDONS_CLICK: 'Manage Addons - Manage Free Addons - Click', //free only
    MANAGE_ADDONS_SELECT_ADDON: 'Addon Selection - Select Addon',
    MANAGE_ADDONS_UNSELECT_ADDON: 'Manage Free Addons - Unselect Addon', //free only
    MANAGE_B2B_ADDONS_ACTIVATE_ADDONS: 'Manage Addons - Activate Addons', //both

    EXPLORE_ADDONS_SELECT_ADDON: 'Explore Addons - Select Addon',
    EXPLORE_ADDONS_UNSELECT_ADDON: 'Explore Addons - Unselect Addon',
    MANAGE_ADDONS_ACTIVATE_ADDONS: 'Manage Addons - Activate Addons',

    AMAZON_ACTIVATION_VIEW: 'Activation Page - View',
    AMAZON_ACTIVATION_ACTIVATE: 'Activation Page - Activate',

    REDEEM_ACTIVATION_FAILURE: 'Redeem Gift Card - Activate - Failure',
    REDEEM_ACTIVATION_ATTEMPT: 'Redeem Gift Card - Activate - Attempt',

    SWITCH_PAYMENT_ATTEMPT: 'Change Payment Method - Attempt',
    SWITCH_PAYMENT_METHOD_SELECT: 'Change Payment Method - Select New',
    SWITCH_PAYMENT_METHOD_VALIDATION_ATTEMPT: 'Change Payment Method - Validation Attempt',
    SWITCH_PAYMENT_METHOD_VALIDATION_SUCCESS: 'Change Payment Method - Validation Success',
    SWITCH_PAYMENT_METHOD_VALIDATION_FAILURE: 'Change Payment Method - Validation Failure',
    SWITCH_PAYMENT_METHOD_SUCCESS: 'Change Payment Method - Success',
    SWITCH_PAYMENT_METHOD_FAILURE: 'Change Payment Method - Failure ',

    PAGE_NOT_FOUND: 'Page Not Found - 404',

    // RESUB_CLICK: 'Resubscribe Click',
    // RESUB_POPUP_VIEW: 'Resubscribe Popup View',
    // MANAGE_ADDONS_UNSUB_ATTEMPT: "Unsubscribe Attempt",
    // MANAGE_ADDONS_UNSUB_SUCCESS: "Unsubscribe Success",
    // MANAGE_ADDONS_UNSUB_FAILED: "Unsubscribe Failed",

    MANAGE_ADDONS_QITAF_APPLY_CLICK: 'Manage Addons - Apply Qitaf',
    MANAGE_ADDONS_SUBSCRIBE_ADDON_ATTEMPT: 'Manage Addons - Subscribe Addon Attempt',
    MANAGE_ADDONS_SUBSCRIBE_ADDON_SUCCESS: 'Manage Addons - Subscribe Addon Success',
    MANAGE_ADDONS_SUBSCRIBE_ADDON_FAILED: ' Manage Addons - Subscribe Addon Fail',
    MANAGE_ADDONS_SEND_VERIFY_NUM_FAILED: 'Manage Addons - Send verification number failure',
    MANAGE_ADDONS_PIN_VERIFICATION_VIEW: 'Manage Addons - PIN Verification - View',
    MANAGE_ADDONS_PIN_VERIFICATION_ATTEMPT: 'Manage Addons - PIN Verification - Attempt',
    MANAGE_ADDONS_PIN_VERIFICATION_SUCCESS: 'Manage Addons - PIN Verification - Success',
    MANAGE_ADDONS_PIN_VERIFICATION_FORGOT_PIN: 'Manage Addons - PIN Verification - Forgot PIN',
    MANAGE_ADDONS_PIN_VERIFICATION_FAILED: 'Manage Addons - PIN Verification - Failed',

    // Subscription Events
    PAGE_EVENT: 'Micro Website - [PAYMENT_METHOD]',
    REGISTRATION_SUCCESS: 'Registration Success',
    SUB_OTP_GENERATE: '[CURRENT_PAGE_TITLE] - Subscription OTP Generate',
    SUB_OTP_RESEND: '[CURRENT_PAGE_TITLE] - Subscription OTP Resend',
    SUB_OTP_RESEND_FAILURE: '[CURRENT_PAGE_TITLE] - Subscription OTP Resend Failure',
    SUB_OTP_VERIFY_ATTEMPT: '[CURRENT_PAGE_TITLE] - Subscription OTP Verify Attempt',
    SUB_OTP_VERIFY_FAILURE: '[CURRENT_PAGE_TITLE] - Subscription OTP Verify Failure',
    SUB_ATTEMPT: '[CURRENT_PAGE_TITLE] - Subscription Attempt',
    SUB_SUCCESS: '[CURRENT_PAGE_TITLE] - Subscription Success',
    SUB_FAILURE: '[CURRENT_PAGE_TITLE] - Subscription Failure',
    BUNDLE_ACTIVATE_ATTEMPT: '[OPERATOR] - Activate - Attempt',
    BUNDLE_ACTIVATE_SUCCESS: '[OPERATOR] - Activate - Success',
    BUNDLE_ACTIVATE_FAILURE: '[OPERATOR] - Activate - Failure',
    SUBSCRIPTION_TIER: 'Subscription - Tier',
    PLAN_FEATUERS_VIEWED: 'Plan Features Viewed',
    PLAN_SELECTED: 'Plan Selected',
    ADDONS_SELECTED: 'Addons Selected',
    PAYMENT_METHOD_SELECTED: 'Payment Method Selected',
    SUB_COMPLETED: 'Subscription Completed',
    PASSWORD_SUBMITTED: 'Password Submitted',
    SIGN_UP_STARTED: 'Sign Up Started',
    LANDING_EXPLORE: 'Landing - Explore',
    USERNAME_SUBMITTED: 'Username Submitted',
    QR_CODE_SCANNED: 'QR Code Scanned',
    PAYMENT_SUBMITTED: 'Payment Submitted',
    GIFT_CARD_CODE_SUBMITTED: 'Gift Card Code Submitted',

    START_PAIRING: 'Start Pairing',

    // Discount Events
    DISCOUNT_ATTEMPT: '[CURRENT_PAGE_TITLE] - Promo Code Verification - Attempt',
    DISCOUNT_ATTEMPT_FAILURE: '[CURRENT_PAGE_TITLE] - Promo Code Verification - Failure',
    DISCOUNT_ATTEMPT_SUCCESS: '[CURRENT_PAGE_TITLE] - Promo Code Verification - Success',

    CSAT_POPUP_VIEW: 'VOC - CSAT - Popup View',
    CSAT_SUBMIT: 'VOC - CSAT - Submit',
    CSAT_SURVEY_SUBMIT: 'VOC - Survey - Submit',

    //Delete Account Events
    MYACCOUNT_DELETE_ACCOUNT_CLICK: 'My Account - Delete Account - Click',
    DELETE_ACCOUNT_CONFIRMATION_VIEW: 'Delete Account - Confirmation - View',
    DELETE_ACCOUNT_CONFIRMATION_ATTEMPT: 'Delete Account - Confirmation - Attempt',
    DELETE_ACCOUNT_CONFIRMATION_FAIL: 'Delete Account - Confirmation - Fail',
    DELETE_ACCOUNT_CONFIRMATION_SUCCESS: 'Delete Account - Confirmation - Success',
    DELETE_ACCOUNT_SUBMISSION_FORM_VIEW: 'Delete Account - Submission Form - View',
    DELETE_ACCOUNT_SUBMISSION_FORM_SUBMIT: 'Delete Account - Submission Form - Submit',
    DELETE_ACCOUNT_SUBMISSION_MESSAGE_VIEW: 'Delete Account - Submission Message - View',
    DELETE_ACCOUNT_SUBMISSION_OK: 'Delete Account - Submission Message - OK',
    DELETE_ACCOUNT_SUBMISSION_MANAGE_SUBSCRIPTION: 'Delete Account - Submission Message - Manage Subscription',

    //My Account
    MY_ACCOUNT_VIEW: 'My Account - View',
    MY_ACCOUNT_UPGRADE_ATTEMPT: 'My Account - Upgrade Plan - Attempt',
    MY_ACCOUNT_UNSUBSCRIBE_CLICK: 'My Account - Unsubscribe - Click',
    MY_ACCOUNT_UNSUBSCRIBE_ATTEMPT: 'My Account - Unsubscribe - Attempt',
    MY_ACCOUNT_UNSUBSCRIBE_SUCCESS: 'My Account - Unsubscribe - Success',
    MY_ACCOUNT_UNSUBSCRIBE_FAILURE: 'My Account - Unsubscribe - Failure',
    MY_ACCOUNT_UPGRADE_PLAN_SUCCESS: 'My Account - Upgrade Plan - Success',
    MY_ACCOUNT_UPGRADE_PLAN_FAILURE: 'My Account - Upgrade Plan - Failure',
    MY_ACCOUNT_UPGRADE_PLAN_PIN_VERIFICATION: 'My Account - Pin Verification - View',

    MY_ACCOUNT_CONSENT_MARKETING_PROMPT: 'My account - Consent - Marketing - Prompt',
    SCREEN_VIEWED: 'Screen Viewed',
    CAMPAIGN_SUBSCRIBE: 'Landing Page - Subscribe',
    CAMPAIGN_HE_FLOW_GET_MOBILE_NUMBER: 'Landing Page - HE - Get Mobile Number',
    CAMPAIGN_HE_FLOW_SUCCESS: 'Landing Page - HE - Success',
    CAMPAIGN_SUBSCRIPTION_ATTEMPT_FAILURE: 'Subscription Attempt - Failure',
    CAMPAIGN_HE_SUBSCRIPTION_ATTEMPT_FAILURE: 'Landing Page - HE - Failure',
    CAMPAIGN_PAGE_VIEW: 'Landing Page - View',
    CAMPAIGN_SUBSCRIPTION_VERIFICATION_ATTEMPT: 'Subscription - Verification Attempt',
    CAMPAIGN_SUBSCRIPTION_VERIFICATION_SUCCESS: 'Subscription - Verification Success',
    CAMPAIGN_SUBSCRIPTION_VERIFICATION_FAILURE: 'Subscription - Verification Failure',
    CAMPAIGN_SUBSCRIPTION_SUCCESS: 'Subscription - Success',
    CAMPAIGN_SUBSCRIPTION_FAILURE: 'Subscription - Failure',

    // Disney+ Activation Events
    DISNEY_ACTIVATION_PAGE_VIEWED: 'Disney+ Activation Page Viewed',
    DISNEY_ACTIVATION_MOBILE_NUMBER_SUBMITTED: 'Disney+ Activation Mobile Number Submitted',
    DISNEY_ACTIVATION_OTP_SUBMITTED: 'Disney+ Activation OTP Submitted',
    DISNEY_ACTIVATION_COMPLETED: 'Disney+ Activation Completed',

    // Add-ons Swap Events
    ADDONS_SWAP: 'Add-ons Swap',
    ADDONS_SWAP_COMPLETED: 'Add-ons Swap Completed',

    // Explore Add-ons Events
    EXPLORE_ADDONS: 'Explore Add-ons',
    ADDON_SELECTION_PAGE: 'Add-on Selection Page',

    // P&C Activation Events
    PC_ACTIVATION_COMPLETED: 'P&C Activation Completed',
    ADDON_PURCHASE_COMPLETED: 'Addon Purchase - Completed',
    CANCELLATION_REASON_SUBMITTED: 'Cancelation Reasons',

    ACCOUNT_EXPLORE_ADDON_CLICK: 'Explore Add-ons',
    ADDON_SELECTION_CLICK: 'Addon Selection page',
    OTP_SUBMITTED: 'OTP Submitted',
    OTP_RESENT: 'OTP Resent',

    ADDON_SELECTION_BUNDLE_AND_SAVE: 'Add-on selected - Bundle and Save',
    ADDON_SELECTION_NORMAL: 'Add-on selected - Normal',
    ADDON_SELECTION_PICK_AND_CHOOSE: 'Add-on selected - Pick and Choose',
    ADDON_OTP_SUBMIT: "Add-on OTP Submit",
    MANAGE_ADDON_CLICK: "Manage Add-on Click",



};

export const KOCHAVA_EVENTS = {
    PAGE_EVENT: 'Micro Website - [PAYMENT_METHOD]',
    REGISTRATION_SUCCESS: 'Registration Success',
    LOGIN_SUCCESS: 'Login - Success',
    SUB_OTP_GENERATE: '[CURRENT_PAGE_TITLE] - Subscription OTP Generate',
    SUB_OTP_RESEND: '[CURRENT_PAGE_TITLE] - Subscription OTP Resend',
    SUB_OTP_RESEND_FAILURE: '[CURRENT_PAGE_TITLE] - Subscription OTP Resend Failure',
    SUB_OTP_VERIFY_ATTEMPT: '[CURRENT_PAGE_TITLE] - Subscription OTP Verify Attempt',
    SUB_OTP_VERIFY_FAILURE: '[CURRENT_PAGE_TITLE] - Subscription OTP Verify Failure',
    SUB_SUCCESS: '[CURRENT_PAGE_TITLE] - Subscription Success',
    SUB_FAILURE: '[CURRENT_PAGE_TITLE] - Subscription Failure',
    SUB_PAID: '[CURRENT_PAGE_TITLE] - Subscription Paid',
    BUNDLE_ACTIVATE_ATTEMPT: '[OPERATOR] - Activate - Attempt',
    BUNDLE_ACTIVATE_SUCCESS: '[OPERATOR] - Activate - Success',
    BUNDLE_ACTIVATE_FAILURE: '[OPERATOR] - Activate - Failure',
    SUBSCRIPTION_ATTEMPT: 'Subscription Attempt',
    DISCOUNT_PROMO_ATTEMPT: 'Discount/Promo Attempt',
    CAMPAIGN_PAGE_VIEW: 'Page View',
    CAMPAIGN_SUBSCRIPTION_ATTEMPT: 'Subscription Attempt',
    CAMPAIGN_SUBSCRIPTION_OTP_GENERATE: 'Subscription - OTP Generate',
    CAMPAIGN_SUBSCRIPTION_OTP_VERIFY_ATTEMPT: 'Subscription - OTP Verify Attempt',
    CAMPAIGN_SUBSCRIPTION_SUCCESS: 'Subscription - Subscription Success',
    CAMPAIGN_VIEWERSHIP: 'Viewership',
};

export const BRAZE_EVENTS = {
    SUBSCRIPTION_SUCCESS: 'Subscription - Success',
};

export const USER_SEGMENT = {
    B2C: 'B2C',
    B2B: 'B2B',
    B2B2C: 'B2B2C',
};
export const ADD_ONS_PRICE_LOCATIONS = {
    SWAP_AND_PICK_AND_CHOOSE: 'swapAndpickChoose',
    ORDER_SUMMARY: 'orderSummary',
    CART: 'cart',
    CAROUSEL: 'carousel',
};

export const RECATCHA_ACTION_TYPE = {
    LOGIN_VERIFY: 'verify_user',
    LOGIN_CREDENTIALS: 'login_with_credentials',
    LOGIN_OTP: 'login_with_otp',
    FORGOT_PASSWORD_SEND_OTP: 'forgot_password_send_otp',
    FORGOT_PASSWORD_RESEND_OTP: 'forgot_password_resend_otp',
    FORGOT_PASSWORD_VERIFY_OTP: 'forgot_password_verify_otp',
    FORGOT_PASSWORD_RESET: 'forgot_password_reset',
    AUTHENTICATE_WITH_QR_CODE: 'authenticate_with_qr',
    BOLT_REGISTER_TWO_STEPS: 'bolt_register_two_steps',
    USER_REGISTRATION_GENERATE_PIN: 'user_registration_generate_pin',
    USER_REGISTRATION_VERIFY_PIN: 'user_registration_verify_pin',
    SUBSCRIBE_REGISTER_USER: 'user_registration',
    QITAF_OTP_GENERATE: 'qitaf_generate_otp',
    QITAF_OTP_VERIFY: 'qitaf_verify_otp',
    SIGNUP_QR_POLL: 'signup_qr_poll',
    CONTACT_US_SUBMIT_FORM: 'contact_us_submit_form',
    FORGOT_RESEND_B2B_PIN: 'forgot_resend_b2b_pin',
};

export const SUBSCRIPTION_STATUS = {
    ACTIVE: 'ACTIVE',
    UNSUBSCRIBED: 'UNSUBSCRIBED',
    CANCELLED: 'CANCELLED',
    SUSPENDED: 'SUSPENDED',
    TERMINATED: 'TERMINATED',
    UNKNOWN: 'UNKNOWN',
    ENROLLED: 'ENROLLED',
};

export const SUBSCRIPTION_TIER_ACTIVITY = {
    RENEWAL: 'RENEWAL',
    SUBSCRIPTION: 'SUBSCRIPTION',
    UNSUBSCRIPTION: 'UNSUBSCRIPTION',
};

export const COUNTRY_CODES = {
    KSA: 'KSA',
    BRN: 'BRN',
};
export const APP_TYPE = {
    SLP_MLP: 'SLP_MLP',
    WCP: 'WCP',
    TV: 'TV',
};

export type AppType = (typeof APP_TYPE)[keyof typeof APP_TYPE];

export const CACHE_CONFIG_TYPES = {
    baseConfiguration: 'baseConfiguration.cache.object',
    configuration: 'configuration.cache.object',
    version: 'configuration.cache.version',
    user: 'user',
};

export const playerTypes = {
    Trailer: 'Trailer',
    LiveTV: 'LiveTV',
    Vod: 'Vod',
    Series: 'Series',
    Catchup: 'Catchup',
    PlayTrailer: 'PlayTrailer',
};

export const PPV_PURCHASE_OPTIONS = {
    NONE: null,
    OTP: 'OTP',
    PASSWORD: 'PASSWORD',
    PIN: 'PIN',
    CC: 'CC',
    IAP: 'IAP',
    PF: 'PF',
};

export const ITEM_CATEGORY = {
    VOD: 'vod',
};

// This config has been moved, should be removed after testing...
export const REWARD_QUEST_TYPE = {
    TIER_UPGRADE: 'tier_upgrade',
    SUBSCRIPTION_RENEWAL: 'renew_subscription',
};

export const GAMIFICATION_NOTIFICATIONS = {
    STORED_NOTIFICARIONS: 'stored_notifications',
    STORED_BADGES: 'stored_badges',
};

/** Synthetic profile id for guest browse — must not be sent to profile-scoped APIs. */
export const GUEST_PROFILE_GUID = 'guest-browse-profile';
